export const API_CONFIG = {
  domain: __API_CONFIG.url,
  programCode: __API_CONFIG.program,
  tenantCode: __API_CONFIG.tenant,
  defaultLanguage: 'fr-FR',
} as const

export const API_ENDPOINTS = {
  health: '/api/health',
  brands: (programCode: string) =>
    `/v1/programs/${programCode}/get-brands-with-statuses?periodDays=300`,
  gravityAuth: (programCode: string) =>
    `/v1/programs/${programCode}/authentication/token`,
  spainAuth: (programCode: string) =>
    `/v1/programs/${programCode}/authentication/token`,
  romaniaAuth: (programCode: string) =>
    `/v1/programs/${programCode}/authentication/token`,
  brazilAuth: (programCode: string) =>
    `/v1/programs/${programCode}/authentication/token`,
  profile: (programCode: string) =>
    `/v1/programs/${programCode}/players/profile`,
  participation: (programCode: string) =>
    `/v1/programs/${programCode}/participation`,
  consents: (programCode: string) => `/v1/programs/${programCode}/consents`,
  mockToken: (programCode: string) =>
    `/v1/programs/${programCode}/authentication/mock-token`,
  prizes: (programCode: string) => `/v1/programs/${programCode}/prizes`,
  couponUse: (programCode: string) => `/v1/programs/${programCode}/coupon/use`,
  gamesStatus: (programCode: string, brandId: string) =>
    `/v1/programs/${programCode}/games/status?brandId=${brandId}`,
  gamesAndCommit: (programCode: string, brandId: string) =>
    `/v1/programs/${programCode}/games-and-commit?brandId=${brandId}`,
  recordCommittedResult: (programCode: string) =>
    `/v1/programs/${programCode}/results/record-committed`,
  miniCampaignsParticipation: (programCode: string) =>
    `/v1/programs/${programCode}/mini-campaigns-participation`,
  availableGamesForBrands: (programCode: string) =>
    `/v1/programs/${programCode}/get-available-games-for-brands`,
  scoreAndPosition: (programCode: string, brandId: string) =>
    `/v1/programs/${programCode}/score-and-position?brandId=${brandId.toUpperCase()}`,
}
